<template>
	<h2 class="oomph py-6 text-4xl font-bold text-center uppercase">
		{{ title }}
	</h2>
	<nav class="flex flex-wrap pb-6">
		<article v-for="(item, index) of items" :key="`box-link-${count}-${index}`" class="px-6 py-3 w-1/4">
			<component :is="includes('http', item.url) ? 'a' : 'router-link'" class="block"
				:href="item.url" 
				:to="item.url" 
				:target="includes('http', item.url) ? '_blank' : '_self'"
			>
				<div :style="`background-image: url(${item.image})`" 
					class="bg-white w-full h-64 flex justify-center items-end rounded-md shadow-md bg-cover bg-center bg-no-repeat border-4 border-black"
				>
					<div class="p-2 text-white bg-black">
						<h3 class="font-bold uppercase">
							{{ item.title }}
						</h3>
						<div>{{ item.subtitle }}</div>
					</div>
				</div>
			</component>
		</article>
	</nav>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from 'vue'
import { includes } from 'ramda'

interface BoxLink {
	url: string;
	title?: string;
	subtitle?: string;
	image?: string;
}

const count = ref<number>(0)

export default defineComponent({
	name: 'BoxLinks',

	props: {
		title: { type: String, default: '' },
		items: { type: Array as PropType<BoxLink[]>, default: () => [] }
	},

	setup () {
		count.value++

		return { count, includes }
	}
	
})
</script>